import React from 'react';
import { Atom } from 'react-loading-indicators';

export const AtomLoaderComponent = () => {
    return (
        <Atom
            color="#32cd32"
            size="large"
            text="Slv-WebTech"
            textColor=""
        />
    );
}; 